(() => {
  const root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  const qs = (sel, scope = document) => scope.querySelector(sel);
  let renderVersion = 0;

  function productCardHTML(p) {
    const price = (p.price / 100).toFixed(2).replace(".", ",");
    const compare = p.compare_at_price
      ? (p.compare_at_price / 100).toFixed(2).replace(".", ",")
      : null;

    return `
      <div class="em-wishlist-card">
        <a class="em-wishlist-card__img" href="${p.url}">
          ${p.featured_image ? `<img loading="lazy" src="${p.featured_image}" alt="${p.title}">` : ""}
        </a>

        <div class="em-wishlist-card__meta">
          <a class="em-wishlist-card__title" href="${p.url}">${p.title}</a>

          <div class="em-wishlist-card__price">
            ${compare ? `<span class="em-wishlist-compare">€${compare}</span>` : ""}
            <span class="em-wishlist-price">€${price}</span>
          </div>

          <button class="em-wishlist-remove" type="button" data-em-remove="${p.handle}">
            Retirer
          </button>
        </div>
      </div>
    `;
  }

  async function fetchProducts(handles) {
    const settled = await Promise.all(
      handles.map(async (handle) => {
        try {
          const res = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
            credentials: "same-origin"
          });
          if (!res.ok) throw new Error("fetch failed");
          return await res.json();
        } catch (e) {
          if (window.EMWishlist && window.EMWishlist.remove) {
            window.EMWishlist.remove(handle);
          }
          return null;
        }
      })
    );

    return settled.filter(Boolean);
  }

  async function render() {
    const page = qs(".em-wishlist-page, #em-wishlist-page, [data-em-wishlist-page]");
    if (!page) return;

    const grid = qs("[data-em-wishlist-grid], .em-wishlist-grid", page);
    const empty = qs("[data-em-wishlist-empty], .em-wishlist-empty", page);
    if (!grid || !empty) return;

    const handles =
      (window.EMWishlist && window.EMWishlist.getAll && window.EMWishlist.getAll()) || [];

    const currentRender = ++renderVersion;

    if (!handles.length) {
      grid.innerHTML = "";
      grid.hidden = true;
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = `<div class="em-wishlist-loading">Chargement…</div>`;

    const results = await fetchProducts(handles);

    if (currentRender !== renderVersion) return;

    if (!results.length) {
      grid.innerHTML = "";
      grid.hidden = true;
      empty.hidden = false;
      return;
    }

    grid.hidden = false;
    empty.hidden = true;
    grid.innerHTML = results.map(productCardHTML).join("");
  }

  function init() {
    render();
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-em-remove]");
    if (!btn) return;

    e.preventDefault();

    const handle = btn.getAttribute("data-em-remove");
    if (window.EMWishlist && window.EMWishlist.remove) {
      window.EMWishlist.remove(handle);
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);

  window.addEventListener("pageshow", render);
  window.addEventListener("em:wishlist:changed", render);

  window.addEventListener("storage", (e) => {
    if (e.key && e.key.toLowerCase().includes("wishlist")) render();
  });
})();